import { Injectable, inject } from '@angular/core';
import { ConsentAccountResponse } from '@cropx-web/screens/oauth2/model/ConsentAccount';
import { ApiGatewayService } from '@cropx-web/services/api-gateway/ApiGatewayService';
import {
  Action,
  State,
  StateContext,
  createPropertySelectors,
} from '@ngxs/store';
import { EMPTY, Observable, catchError, tap, throwError } from 'rxjs';

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace OAuth2 {
  const type = 'oauth2';

  export class ConsentAccount {
    static readonly type = `[${type}] ConsentAccount`;

    constructor(public body: any) {}
  }

  export class GetClient {
    static readonly type = `[${type}] GetClient`;

    constructor(public client_id: any) {}
  }
}

export interface OAuth2StateModel {
  isLoading: boolean;

  redirect_uri: string | null;
  client_name: string | null;
}

@State<OAuth2StateModel>({
  name: 'oauth2',
  defaults: {
    isLoading: false,
    redirect_uri: null,
    client_name: null,
  },
})
@Injectable()
export class OAuth2State {
  private api = inject(ApiGatewayService);

  @Action(OAuth2.ConsentAccount)
  consentAccount(
    ctx: StateContext<OAuth2StateModel>,
    action: OAuth2.ConsentAccount,
  ): Observable<ConsentAccountResponse> {
    const { body } = action;
    ctx.patchState({ isLoading: true });

    return this.api.oauth2.consentAccount(body).pipe(
      tap((response) => {
        ctx.patchState({
          isLoading: false,
          redirect_uri: response.redirect_uri,
        });

        return response;
      }),
      catchError(() => {
        ctx.patchState({ isLoading: false });
        return throwError(() => null);
      }),
    );
  }

  @Action(OAuth2.GetClient)
  getClient(
    ctx: StateContext<OAuth2StateModel>,
    action: OAuth2.GetClient,
  ): Observable<any> {
    const { client_id } = action;
    ctx.patchState({ isLoading: true });

    return this.api.oauth2.getClient(client_id).pipe(
      tap((response) => {
        ctx.patchState({
          isLoading: false,
          client_name: response.clientName,
        });
      }),
      catchError(() => {
        ctx.patchState({ isLoading: false });
        return EMPTY;
      }),
    );
  }
}

export class OAuth2Selectors {
  static slices = createPropertySelectors<OAuth2StateModel>(OAuth2State);
}
